import type { AppBindingResponse } from "@/types/api";

export function storagePlacementRepairHelp(modeId: AppBindingResponse["modeId"]): string {
  return modeId === "shared_storage"
    ? "共有フォルダのファイルを正しく開けるよう、レコードに保存された添付情報を修復します。共有フォルダ内のファイルの場所や名前は変更しません。"
    : "フォルダ名や添付フィールドの設定を変更したときに、ファイルを設定に合う保存場所へ移し、レコードの添付情報も更新します。";
}
